<template>
    <div ref="translateRef" >
        <div class="relative">
            <div class="rounded hover:bg-grey-60/20" @click.stop="dropdown = !dropdown">
                <PtIcon icon="OperationIcon" class="text-2xl"/>
            </div>
            <ul class="th-menu absolute right-0 z-10 mt-1 w-40" v-show="dropdown">
                <li @click.stop="handlePinProject" v-if="!project.pinned">
                    <PtIcon icon="TopIcon" class="th-menu-item-pre-icon text-2xl"/>
                    {{t('pin')}}
                </li>
                <li @click.stop="handleDeleteProject">
                    <PtIcon icon="DeleteIcon" class="th-menu-item-pre-icon text-2xl"/>
                    {{ t('remove') }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { onClickOutside } from '@vueuse/core'
import { openMessageBox } from '@eureka/confirm-box';
import type { IProject } from '@/types'
import { PtIcon } from 'patsnap-biz'
import '@/assets/icons/operationIcon.svg'
import '@/assets/icons/deleteIcon.svg'
import '@/assets/icons/topIcon.svg'

import { useI18n } from 'vue-i18n';
const { t } = useI18n()

const dropdown = ref(false)
const translateRef = ref(null)

const props = defineProps<{
    project: IProject
}>()

const emits = defineEmits<{
    (e: 'remove-project', id: string): void
    (e: 'pin-project', id: string): void
}>()

onClickOutside(
    translateRef,
    (e) => {
        dropdown.value = false
    }
)

function handlePinProject() {
    dropdown.value = false
    emits('pin-project', props.project.project_id)
}

async function handleDeleteProject() {
    dropdown.value = false
    const confirm = await openMessageBox({
        title: t('removeTitle'),
        message: t('removeMessage'),
        confirmButtonText: t('removeConfirm'),
        cancelButtonText: t('removeCancel'),
    });
    if (confirm) {
        emits('remove-project', props.project.project_id)
    }
}
</script>
